export default class Modal {
	constructor(id, triggerElement = document.body) {
		this.focusableElements =
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
		this.triggerElement = triggerElement;
		if (utilities.isDomElement(id)) {
			this.elem = id;
		} else {
			this.elem = document.querySelector("[data-id='" + id + "']");
		}
		if (this.elem) {
			this.closeButton = this.elem.querySelector(".close-modal");
			this.focusableContent = this.elem.querySelectorAll(
				this.focusableElements
			);
			this.firstFocusableElement = this.focusableContent[0]; // get first element to be focused inside modal
			this.lastFocusableElement = this.focusableContent[
				this.focusableContent.length - 1
			]; // get last element to be focused inside modal

			this.init();
		}
	}
	init() {
		this.attachEvents();
		utilities.setAriaProp(this.elem, "hidden", true);
	}

	// Create event listeners for close modal
	attachEvents() {
		const self = this;
		// Hide modal when you press close
		document.onkeydown = function(evt) {
			if (evt.keyCode == utilities.keys.escape) {
				self.hide();
			} else if (evt.keyCode == utilities.keys.tab) {
				if (evt.shiftKey) {
					// if shift key pressed for shift + tab combination
					if (document.activeElement === self.firstFocusableElement) {
						self.lastFocusableElement.focus(); // add focus for the last focusable element
						evt.preventDefault();
					}
				} else {
					// if tab key is pressed
					if (document.activeElement === self.lastFocusableElement) {
						// if focused has reached to last focusable element then focus first focusable element after pressing tab
						self.firstFocusableElement.focus(); // add focus for the first focusable element
						evt.preventDefault();
					}
				}
			} else {
				return;
			}
		};
		if (this.elem) {
			this.elem.addEventListener("click", e => {
				if (e.target.classList.contains("close-modal")) {
					this.hide();
				}
			});
			this.elem.addEventListener("click", e => {
				if (e.target.classList.contains("modal-azr")) {
					this.hide();
				}
			});
		}
	}
	show(callback) {
		if (this.elem) {
			document.body.style.overflow = "hidden";
			this.elem.style.display = "block";
			utilities.setAriaProp(this.elem, "hidden", false);
			document.body.appendChild(this.elem); //move modals outside
			this.closeButton.focus();
			if (callback) callback();
		}
	}

	hide(callback) {
		document.body.style.overflow = "auto";
		this.elem.style.display = "none";
		//this.bodyElement.removeChild(this.elem); //move modals outside
		this.createCloseEvent();
		this.triggerElement.focus();
		if (callback) callback();
	}

	createCloseEvent() {
		let event = new Event("AzrModalClose");
		document.dispatchEvent(event);
	}
}
